import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './AuthPage.css';
import logo from '../assets/logos/dama.jpeg';

const AuthPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [mode, setMode] = useState(location.state?.mode || 'login');

  useEffect(() => {
    if (location.state?.mode) {
      setMode(location.state.mode);
      setLoginError('');
      setSubError('');
    }
  }, [location.state]);

  const [loginData, setLoginData] = useState({ email: '', password: '' });
  const [loginError, setLoginError] = useState('');

  const [subData, setSubData] = useState({
    email: '', prenom: '', nom: '', password: '', organisation: ''
  });
  const [subError, setSubError] = useState('');

  const getUsers = () => JSON.parse(localStorage.getItem('dama_users') || '[]');
  const saveUsers = (users) => localStorage.setItem('dama_users', JSON.stringify(users));
  const saveSession = (user) => localStorage.setItem('dama_current_user', JSON.stringify(user));

  const handleLogin = (e) => {
    e.preventDefault();
    setLoginError('');
    const users = getUsers();
    const found = users.find(
      u => u.email === loginData.email && u.password === loginData.password
    );
    if (!found) {
      setLoginError('Email ou mot de passe incorrect.');
      return;
    }
    saveSession(found);
    navigate('/');
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    setSubError('');
    const users = getUsers();
    const exists = users.find(u => u.email === subData.email);
    if (exists) {
      setSubError('Cet email est déjà utilisé. Veuillez vous connecter.');
      return;
    }
    const newUser = { ...subData };
    saveUsers([...users, newUser]);
    saveSession(newUser);
    navigate('/');
  };

  return (
    <div className="auth-page">
      <div className="auth-card">

        {/* ── Bouton fermer ── */}
        <button className="auth-close" onClick={() => navigate(-1)}>✕</button>

        {/* Logo */}
        <div className="auth-logo">
          <img src={logo} alt="DAMA Tunisia" />
          <div>
            <span className="auth-logo-title">DAMA <span>Tunisia</span></span>
            <p>Together, towards responsible DATA</p>
          </div>
        </div>

        {/* ── LOGIN FORM ── */}
        {mode === 'login' && (
          <form className="auth-form" onSubmit={handleLogin}>
            <h2>Welcome back</h2>
            <p className="auth-subtitle">Connectez-vous à votre compte DAMA Tunisia</p>

            {loginError && <div className="auth-error">{loginError}</div>}

            <div className="auth-field">
              <label>Email</label>
              <input
                type="email"
                placeholder="votre@email.com"
                required
                value={loginData.email}
                onChange={e => setLoginData({ ...loginData, email: e.target.value })}
              />
            </div>

            <div className="auth-field">
              <label>Mot de passe</label>
              <input
                type="password"
                placeholder="••••••••"
                required
                value={loginData.password}
                onChange={e => setLoginData({ ...loginData, password: e.target.value })}
              />
            </div>

            <button type="submit" className="auth-submit">Se connecter</button>
          </form>
        )}

        {/* ── SUBSCRIBE FORM ── */}
        {mode === 'subscribe' && (
          <form className="auth-form" onSubmit={handleSubscribe}>
            <h2>Créer un compte</h2>
            <p className="auth-subtitle">Rejoignez la communauté DAMA Tunisia</p>

            {subError && (
              <div className="auth-error">
                {subError}
                {subError.includes('déjà utilisé') && (
                  <button
                    type="button"
                    className="auth-error-link"
                    onClick={() => navigate('/login', { state: { mode: 'login' } })}
                  >
                    → Se connecter
                  </button>
                )}
              </div>
            )}

            <div className="auth-field">
              <label>Email *</label>
              <input
                type="email"
                placeholder="votre@email.com"
                required
                value={subData.email}
                onChange={e => setSubData({ ...subData, email: e.target.value })}
              />
            </div>

            <div className="auth-row">
              <div className="auth-field">
                <label>Prénom *</label>
                <input
                  type="text"
                  placeholder="Prénom"
                  required
                  value={subData.prenom}
                  onChange={e => setSubData({ ...subData, prenom: e.target.value })}
                />
              </div>
              <div className="auth-field">
                <label>Nom *</label>
                <input
                  type="text"
                  placeholder="Nom"
                  required
                  value={subData.nom}
                  onChange={e => setSubData({ ...subData, nom: e.target.value })}
                />
              </div>
            </div>

            <div className="auth-field">
              <label>Organisation</label>
              <input
                type="text"
                placeholder="Votre organisation (optionnel)"
                value={subData.organisation}
                onChange={e => setSubData({ ...subData, organisation: e.target.value })}
              />
            </div>

            <div className="auth-field">
              <label>Mot de passe *</label>
              <input
                type="password"
                placeholder="Minimum 6 caractères"
                required
                minLength={6}
                value={subData.password}
                onChange={e => setSubData({ ...subData, password: e.target.value })}
              />
            </div>

            <button type="submit" className="auth-submit">Créer mon compte</button>
          </form>
        )}

      </div>
    </div>
  );
};

export default AuthPage;